export const validateStake = (stake, constraints) => {
  const errors = [];

  if (Number.isNaN(stake) || stake < constraints.minStake) {
    errors.push({
      field: 'stake',
      message: `Stake must be at least ${constraints.minStake}`,
    });
  }

  if (stake > constraints.maxStake) {
    errors.push({
      field: 'stake',
      message: `Stake cannot exceed ${constraints.maxStake.toFixed(2)}`,
    });
  }

  return { isValid: errors.length === 0, errors };
};

export const validateBalls = (numbers, constraints) => {
  const errors = [];
  const normalValues = [];
  const bonusValues = [];

  for (let i = 0; i < numbers.length; i++) {
    const num = numbers[i];
    const { value } = num;

    if (!value || Number.isNaN(value)) {
      errors.push({ field: 'balls', index: i, message: 'This field cannot be empty' });
      continue;
    }

    if (num.type === 'NORMAL') {
      if (value < 1 || value > constraints.mainGridTotal) {
        errors.push({
          field: 'balls',
          index: i,
          message: `Value must be between 1 and ${constraints.mainGridTotal}`,
        });
        continue;
      }
      if (normalValues.includes(value)) {
        errors.push({ field: 'balls', index: i, message: 'Numbers must be unique' });
        continue;
      }
      normalValues.push(value);
    } else if (num.type === 'BONUS') {
      if (value < 1 || value > constraints.secondaryGridTotal) {
        errors.push({
          field: 'balls',
          index: i,
          message: `Value must be between 1 and ${constraints.secondaryGridTotal}`,
        });
        continue;
      }
      if (bonusValues.includes(value)) {
        errors.push({ field: 'balls', index: i, message: 'Numbers must be unique' });
        continue;
      }
      bonusValues.push(value);

      if (constraints.secondaryUnique && normalValues.includes(value)) {
        errors.push({
          field: 'balls',
          index: i,
          message: 'Bonus ball must be unique from normal balls',
        });
      }
    }
  }

  return { isValid: errors.length === 0, errors };
};

export const validateTicketState = (
  stake,
  balls,
  hasBalls,
  stakeConstraints,
  ballConstraints
) => {
  const allErrors = [];
  const stakeResult = validateStake(stake, stakeConstraints);
  allErrors.push(...stakeResult.errors);

  if (hasBalls) {
    const ballsResult = validateBalls(balls, ballConstraints);
    allErrors.push(...ballsResult.errors);
  }

  return { isValid: allErrors.length === 0, errors: allErrors };
};
